import React from 'react';
import { Table, Text, ScrollArea, Skeleton } from '@mantine/core';

type Column = {
  label: string;
  key: string;
};

type DataTableProps<T> = {
  data: T[];
  columns: Column[];
  renderRow: (item: T) => React.ReactNode;
  loading?: boolean;
};

function DataTable<T extends Record<string, any>>({
  data,
  columns,
  renderRow,
  loading = false,
}: DataTableProps<T>) {

  return (
    <>
      <ScrollArea>
        {loading ? (
          <>
			<Skeleton height={40} radius="sm" />
			<Skeleton height={90} mt={12} radius="sm" />
			<Skeleton height={90} mt={12} radius="sm" />
			<Skeleton height={90} mt={12} radius="sm" />
			<Skeleton height={90} mt={12} radius="sm" />
          </>
        ) : (
          <Table highlightOnHover>
            <thead>
              <tr>
                {columns.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item) => renderRow(item))
              ) : (
                <tr>
                  <td colSpan={columns.length}>
                    <Text align="center" color="dimmed" my="xl">
                      Sin resultados
                    </Text>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </ScrollArea>
    </>
  );
}

export default DataTable;
